import { getPushPublicKey, pushSubscribe, pushUnsubscribe } from "@/lib/api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
};

export const pushSupported = () =>
  process.env.REACT_APP_PUSH_ENABLED !== "false" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export const getPushPermission = () =>
  pushSupported() ? Notification.permission : "unsupported";

export const getSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
};

// Requests permission (the browser allow/deny popup) then subscribes + registers
// the subscription with the backend. Must be called from a user gesture.
export const enablePush = async () => {
  if (!pushSupported()) return { permission: "unsupported" };
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return { permission };
  const publicKey = await getPushPublicKey();
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  await pushSubscribe(sub.toJSON());
  return { permission, subscribed: true };
};

export const disablePush = async () => {
  const sub = await getSubscription();
  if (!sub) return;
  await pushUnsubscribe(sub.endpoint).catch(() => {});
  await sub.unsubscribe().catch(() => {});
};
